import React, { ReactNode } from "react";
import styled from "styled-components";
import { X } from "lucide-react";
import {
  getNewLookTokens,
  NEW_LOOK_RADIUS,
  newLookType,
} from "common/NewLook/tokens.ts";

interface FilterChipProps {
  children: ReactNode;
  clearLabel: string;
  onClear: () => void;
  compact?: boolean;
}

const FilterChip = ({
  children,
  clearLabel,
  onClear,
  compact,
}: FilterChipProps) => (
  <Chip
    type="button"
    onClick={onClear}
    aria-label={clearLabel}
    title={clearLabel}
    $compact={!!compact}
  >
    {children}
    <X size={12} strokeWidth={2} />
  </Chip>
);

export default FilterChip;

const Chip = styled.button<{ $compact: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: ${(p) => (p.$compact ? 22 : 32)}px;
  padding: 0 ${(p) => (p.$compact ? 8 : 10)}px;
  border: 1px solid ${(p) => getNewLookTokens(p.theme).accent};
  border-radius: ${(p) =>
    p.$compact ? NEW_LOOK_RADIUS.chip : NEW_LOOK_RADIUS.control}px;
  background: transparent;
  color: ${(p) => getNewLookTokens(p.theme).accent};
  cursor: pointer;
  font: inherit;
  ${(p) => p.$compact && newLookType.meta};
  white-space: nowrap;
  &:hover {
    background: ${(p) => getNewLookTokens(p.theme).rowHover};
  }
  &:focus-visible {
    outline: 2px solid ${(p) => getNewLookTokens(p.theme).focus};
  }
`;
